module.exports = __webpack_public_path__ + "media/audio79.b37b4ffc.mp3";